"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-6sq5gj-0"
})(["&.for-close-icon{display:flex;margin-top:", ";}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 0 : "3px";
});

var Close = function Close(props) {
  return _react["default"].createElement(Svg, {
    "aria-labelledby": "close-title",
    className: props.className,
    isMobile: props.isMobile,
    role: "img",
    version: "1.1",
    viewBox: "0 0 14 14",
    width: props.width,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("title", {
    id: "close-title"
  }, "Close"), _react["default"].createElement("desc", null, "Close Icon"), _react["default"].createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-291.000000, -25.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, _react["default"].createElement("g", {
    transform: "translate(286.000000, 20.000000)"
  }, _react["default"].createElement("polygon", {
    points: "19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"
  })))));
};

var _default = Close;
exports["default"] = _default;